import { useHandler } from '@surglogs-app/hooks'

import type { AnalyticsServiceCaptureEventData } from './types'
import { useEventCapture } from './useEventCapture'

export const useCaptureModalToggleEvent = () => {
  const { captureEvent } = useEventCapture()

  const captureModalToggleEvent = useHandler(
    async (
      toggleAction: 'open' | 'close',
      data: Omit<
        AnalyticsServiceCaptureEventData<'modal_toggled'>,
        'toggle_action'
      >,
    ) => {
      await captureEvent('modal_toggled', {
        toggle_action: toggleAction,
        ...data,
      })
    },
  )

  return { captureModalToggleEvent }
}
